import { AfterViewInit, Component, ElementRef, Input } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

declare var bootstrap: any;

@Component({
  selector: 'app-people-status-icon',
  standalone: true,
  imports: [CommonModule, TranslatePipe, DatePipe],
  templateUrl: './people-status-icon.component.html',
  styleUrl: './people-status-icon.component.scss'
})
export class PeopleStatusIconComponent implements AfterViewInit{
  @Input() icon!: string;
  @Input() color!: string;
  @Input() message!: string;
  @Input() date!: Date | null;
  
  constructor(private elementRef: ElementRef) {}

  ngAfterViewInit(): void {
    // Initialise l'infobulle après que l'élément soit rendu dans le DOM
    new bootstrap.Tooltip(this.elementRef.nativeElement.querySelector('i'));
  }
}
